document.querySelectorAll("select").forEach((select) => {
    const openModifier = "__open";

    // Detect when dropdown opens via mouse
    select.addEventListener("mousedown", () => {
        setTimeout(() => {
            select.classList.add(openModifier);
        }, 0);
    });

    // Detect when dropdown opens via keyboard
    select.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
            setTimeout(() => {
                select.classList.add(openModifier);
            }, 0);
        } else if (e.key === "Escape") {
            select.classList.remove(openModifier);
        }
    });

    // Remove class when an option is selected
    document.addEventListener("mousedown", (e) => {
        if (e.target && e.target.tagName.toLowerCase() === "option" && e.target.parentNode === select) {
            select.classList.remove(openModifier);
        }
    });

    // Remove class when the dropdown closes
    select.addEventListener("blur", () => {
        setTimeout(() => {
            select.classList.remove(openModifier);
        }, 0);
    });

    // Handle selection change
    select.addEventListener("change", () => {
        select.classList.remove(openModifier);
    });
});
